import { getAnalytics, logEvent } from 'firebase/analytics';
import { analytics } from '../services/firebase';

// Generic event tracking function
export const trackEvent = (eventName: string, eventParams: Record<string, any> = {}) => {
  try {
    if (analytics) {
      logEvent(analytics, eventName, eventParams);
    }
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
};

// Page view tracking
export const trackPageView = (pagePath: string, pageTitle: string) => {
  trackEvent('page_view', {
    page_path: pagePath,
    page_title: pageTitle
  });
};

// Subscription conversion tracking
export const trackSubscription = (source?: string) => {
  trackEvent('subscribe', {
    event_category: 'engagement',
    event_label: source || 'subscription_form'
  });
};

// Language change tracking
export const trackLanguageChange = (previousLang: string, newLang: string) => {
  trackEvent('language_change', {
    previous_language: previousLang,
    new_language: newLang
  });
};

// Admin actions tracking
export const trackAdminAction = (actionType: string, details: Record<string, any> = {}) => {
  trackEvent('admin_action', {
    action_type: actionType,
    ...details
  });
};